<template>
  <div class="search-container">
    <h2>Selecione um ou mais pontos no campo abaixo:</h2>
    <v-select v-model="selectedStops" as="name::stopId" :from="loadStops" :clearOnSelect="false" @change="selectStop()" />

    <div class="config">
      <div class="options">
        <div class=panel-header>
          <label for="painelHeader">
            Título do painel
          </label>
          <input id="panelHeader" type="text" v-model="panelHeader" placeholder="Título para ser exibido no painel" />
        </div>

        <div>
          <label for="pages">
            Máximo de páginas
          </label>
          <input type="number" id="pages" min="1" max="99" maxlength="2" v-model="pages" />
        </div>

        <div>
          <input type="checkbox" id="timeLimit" v-model="timeLimit" />
          <label for="timeLimit">
            Limitar previsões até
            <input type="number" min="1" max="24" v-model="hoursAheadLimit" :disabled="!timeLimit" />
            horas à frente
          </label>
        </div>

        <div>
          <input type="checkbox" id="showNextDay" v-model="showNextDay" :disabled="timeLimit" />
          <label for="showNextDay">
            Mostrar previsões do dia seguinte
          </label>
        </div>

        <div>
          <input type="checkbox" id="showVehicle" v-model="showVehicle" />
          <label for="showVehicle">
            Mostrar número do veículo
          </label>
        </div>
      </div>

      <div class="action-buttons">
        <button :disabled="selectedStops.length == 0" @click="openReport(true)">Abrir painel nova aba</button>
        <button :disabled="selectedStops.length == 0" @click="openReport()">Abrir painel</button>
      </div>
    </div>

  </div>
</template>

<script>
import Vue from 'vue';
import '@desislavsd/vue-select/dist/vue-select.css'
import { vSelect } from '@desislavsd/vue-select'

export default {
  components: { vSelect },

  data () {
    return {
      panelHeader: '',
      selectedStops: [],
      pages: parseInt(window.localStorage['pages'] || '3'),
      timeLimit: window.localStorage['timeLimit'] == 'true',
      hoursAheadLimit: parseInt(window.localStorage['hoursAheadLimit'] || '24'),
      showNextDay: (window.localStorage['showNextDay'] || 'true') == 'true',
      showVehicle: window.localStorage['showVehicle'] == 'true',
    }
  },

  methods: {
    async loadStops(search) {
      return this.$axios
        .get(`${Vue.config.API_ENDPOINT}/search-stops?project_hash=${this.$route.params.project}&search=${search}`)
        .then(response => response.data);
    },
    selectStop() {
      if (this.selectedStops.length == 1) {
        this.panelHeader = this.selectedStops[0].name;
      }

      if (this.timeLimit) {
        this.showNextDay = false;
      }

      window.localStorage['pages'] = this.pages;
      window.localStorage['timeLimit'] = this.timeLimit;
      window.localStorage['hoursAheadLimit'] = this.hoursAheadLimit;
      window.localStorage['showNextDay'] = this.showNextDay;
      window.localStorage['showVehicle'] = this.showVehicle;
    },
    removeStop(index) {
      this.selectedStops.splice(index, 1);
    },
    openReport(newTab = false) {
      const params = [
        'data=' + btoa(JSON.stringify({
          panelHeader: this.panelHeader,
          stopIds: this.selectedStops.map(s => s.stopId),
          maxPages: this.pages,
          timeLimit: this.timeLimit,
          hoursAheadLimit: this.hoursAheadLimit,
          showNextDay: this.showNextDay,
          showVehicle: this.showVehicle
        }))
      ];

      const url = `/${this.$route.params.project}/${this.selectedStops[0].stopId}?${params.join('&')}`;
      if (newTab) {
        window.open(this.$router.resolve(url).href, '_blank');
      } else {
        this.$router.push(url);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.search-container {
  text-align: center;
  max-width: 900px;
  margin: 50px auto;
  padding: 0 10px;

  h2 {
    font-weight: 400;
    padding: 10px 0;
  }
  .v-select {
    font-size: 1rem;
    text-align: left;
  }

  .config {
    display: flex;
    margin: 1rem 0;

    > div {
      padding: 0 1rem;
    }

    .options {
      flex: 1;
      text-align: left;

      > div {
        margin-bottom: .5rem;
      }

      .panel-header {
        display: flex;
        gap: 4px;

        label {
          white-space: nowrap;
        }
        input {
          width: 100%;
        }
      }
    }
  }

  .action-buttons {
    display: flex;
    gap: 10px;
    justify-content: center;
    align-items: start;
  }
}

@media screen and (max-width: 768px) {
  .config {
    flex-direction: co;
  }
}

input {
  padding: 4px 8px;
  border-radius: 4px;
  border: 1px solid #888;

  &:hover {
    box-shadow: 0 0 0 3px #ddd;
  }
  &[type='checkbox']:hover {
    box-shadow: none;
  }
}
button {
  padding: 8px 12px;
  border-radius: 4px;
  border: none;
  background-color: #0172ad;
  color: #fff;

  &:hover {
    background-color: #02659a;
  }
}
</style>